<template>
  <div class="home">
    <!-- 幻灯片,用户登录 -->
    <div class="home-focus-layout">
      <el-carousel height="570px">
        <el-carousel-item v-for="(item, index) in banner" :key="index">
          <a :href="item.wap_url"><img :src="item.pic" style="width: 100%;" /></a>
        </el-carousel-item>
      </el-carousel>
      <!-- 用户登录 -->
      <div class="right-sidebar">
        <div class="mod_personal_center" v-if="is_login && user">
          <router-link :to="{
            path: '/user/center',
          }">
            <div class="avata_pic_wrap">
              <a id="index_account_icon_login" href="javascript:void(0)"><img class="lazyload"
                  :data-original="user.avatar" :src="user.avatar" style="display: inline;" /></a>
            </div>
          </router-link>
          <div class="info_wrap">
            <div class="login_box">
              <div class="user_info clearfix">
                <em>Hi，{{ user.nickname }}</em>
              </div>
              <div class="clearfix treasure">
                <router-link :to="{
                  path: '/user/order',
                  query: {
                    type: 1
                  }
                }">
                  <a href="javascript:void(0)" target="_blank" class="gold_coin">
                    <em>{{ user.orderStatusNum.unshipped_count }}</em>
                    <p>待发货</p>
                  </a>
                </router-link>
                <router-link :to="{ path: '/user/order', query: { type: 2} }">
                  <a href="javascript:void(0)" target="_blank" class="gold_coin">
                    <em>{{ user.orderStatusNum.received_count }}</em>
                    <p>待收货</p>
                  </a>
                </router-link>

                <router-link :to="{ path: '/user/order', query: { type: 3} }">
                  <a href="javascript:void(0)" target="_blank">
                    <em>{{ user.orderStatusNum.evaluated_count }}</em>
                    <p>待评价</p>
                  </a>
                </router-link>
              </div>
            </div>
          </div>
          <div class="top_line">
            <div class="vip_list">
              <a href="javascript:void(0)">
                <i class="iconfont" style="background:#ff9b1b"></i>
                <p class="vip_item_text">买家保障</p>
              </a>
              <a href="javascript:void(0)">
                <i class="iconfont" style="background:#52a6ff"></i>
                <p class="vip_item_text">商家认证</p>
              </a>
              <a href="javascript:void(0)">
                <i class="iconfont" style="background:#57c15b"></i>
                <p class="vip_item_text">安全交易</p>
              </a>
              <div class="clear"></div>
            </div>
          </div>
        </div>
        <div class="mod_personal_center" v-else>
          <div class="avata_pic_wrap">
            <router-link id="index_account_icon_unlogin" :to="{
              path: '/login',
            }">
              <img class="lazyload" src="@/assets/images/avatar.png" />
            </router-link>
          </div>
          <div class="info_wrap">
            <div class="unlogin_box">
              <div class="title">Hi~你好!</div>
              <div class="tips"></div>
              <div class="btn_wrap">
                <router-link :to="{
                  path: '/login',

                }" class="login_btn">登录</router-link>
                <router-link :to="{
                  path: '/register',
                }" class="regist_btn">注册</router-link>
              </div>
            </div>
          </div>
          <div class="top_line">
            <div class="vip_list">
              <a href="javascript:void(0)">
                <i class="iconfont" style="background:#ff9b1b"></i>
                <p class="vip_item_text">买家保障</p>
              </a>
              <a href="javascript:void(0)">
                <i class="iconfont" style="background:#52a6ff"></i>
                <p class="vip_item_text">商家认证</p>
              </a>
              <a href="javascript:void(0)">
                <i class="iconfont" style="background:#57c15b"></i>
                <p class="vip_item_text">安全交易</p>
              </a>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 品牌专区 -->
    <brand-area></brand-area>
    <activity-area></activity-area>
    <!-- 楼层 -->
    <div class="floor_wrap">
      <div class=" floor floor0 w1200" style="height:0"></div>
      <div :class="setFloorClass(index)" v-for="(item, index) in floor_list" :key="index">
        <div class="floor-left">
          <div class="title">
            <h2 title=""> {{item.cate_name}}</h2>
          </div>
          <div class="left-ads">
            <a href="javascript:void(0)" title="" v-if="item.h_pic != ''">
              <img class="lazyload h_pic" :data-original="item.h_pic" style="display: inline;" :src="item.h_pic">
            </a>
            <a href="javascript:void(0)" title="" v-else>
              <img class="lazyload h_pic" data-original="@/assets/images/floor1.jpg" style="display: inline;"
                src="@/assets/images/floor1.jpg">
            </a>
          </div>
        </div>
        <div class="floor-right">
          <ul :class="index + ' tabs-nav hd'">
            <li>
              <router-link :to="{
                  path: '/good/list',
                  query: {
                  id: item.id,
                  title: item.cate_name,
                  type: 3,

                }
              }">
                <h3>查看更多</h3>
              </router-link>

            </li>
            <li v-for="(s_item, s_index) in item.cate_list" :key="s_index"
              :class="s_index == item.cate_list.length-1 ? index + ' ' + s_index + ' on' : index + ' ' + s_index"
              @mouseover="clickCate(index, s_index)">
              <h3>{{s_item.cate_name}}</h3>
            </li>
          </ul>
          <div :class="index + ' goods-list bd'">
            <ul v-for="(s_item, s_index) in item.cate_list" :key="s_index"
              :style="{display: s_index == item.cate_list.length-1 ? 'block' : 'none'}">
              <li v-for="(c_item, c_index) in s_item.product_list.data" :key="c_index">

                <dl>
                  <dd class="goods-thumb">
                    <router-link :to="{
                      path: '/good/detail/' + c_item.id,

                    }">
                      <a target="_blank" href="javascript:void(0)">
                        <img class="lazyload" :data-original="c_item.image" :alt="c_item.store_name" :src="c_item.image"
                          style="display: inline;">
                      </a>
                    </router-link>
                  </dd>
                  <dt class="goods-name"><a href="javascript:void(0)"
                      :title="c_item.store_name">{{c_item.store_name}}</a>
                  </dt>
                  <dd class="goods-price">
                    <em>{{c_item.price}}</em>
                  </dd>
                </dl>
              </li>
            </ul>
          </div>
        </div>
        <div class="floor-banner">
          <a href="javascript:void(0)" title="" v-if="item.w_pic == ''">
            <img class="lazyload w_pic" data-original="@/assets/images/floor2.png" style="display: inline;"
              src="@/assets/images/floor2.png">
          </a>
          <a href="javascript:void(0)" title="" v-else>
            <img class="lazyload w_pic" :data-original="item.w_pic" style="display: inline;" :src="item.w_pic">
          </a>
        </div>
      </div>
    </div>
    <div class="wrapper mt10"></div>
    <div class="footer-line"></div>
    <div class="fsFixedTopContent" style="visibility: visible;">
      <div class="fsFixedTop" style="opacity: 1; transform: scale(1);">
        <a class="smooth" href="javascript:;" v-for="(item, index) in floor_list" :key="index"
          @click="clickSmooth(index)">
          <b class="fs">{{ index + 1 }}F</b>
          <em class="fs-name">{{ item.cate_name }}</em>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  import $ from "jquery";
  // import SuperSlide from 'vue-superslide'
  import "@/assets/styles/index.css";
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper";
  import {
    getFloorList,
    getBannerList,
    getFloorProducts
  } from "@/api/home";
  import {
    getUser
  } from "@/api/user";
  import "@/assets/plugins/jquery.SuperSlide.2.1.1.js";
  import noRecord from '@/components/NoRecord.vue'
  import StoreStreet from '@/components/StoreStreet'
  import BrandArea from '@/components/BrandArea.vue'
  import ActivityArea from '@/components/ActivityArea.vue'
  export default {
    name: "Home",
    components: {
      swiper,
      swiperSlide,
      noRecord,
      StoreStreet,
      BrandArea,
      ActivityArea
    },
    props: {},
    data: function () {
      return {
        loading: false,
        page: 1,
        limit: 1,
        fids: '0',
        floor_list: [],
        is_loaded_floor: false,
        user: null,
        banner: [],
        category: [],
        options: {
          mainCell: ".bd ul",
          autoPlay: true,
        },
        banner: [],
        swiperOption: {
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay: {
            disableOnInteraction: false,
            delay: 2000,
          },
          loop: true,
          speed: 1000,
          observer: true,
          observeParents: true,
        },
        swiperRoll: {
          direction: "vertical",
          autoplay: {
            disableOnInteraction: false,
            delay: 2000,
          },
          loop: true,
          speed: 1000,
          observer: true,
          observeParents: true,
        },
        swiperScroll: {
          freeMode: true,
          freeModeMomentum: false,
          slidesPerView: "auto",
          observer: true,
          observeParents: true,
        },
        swiperBoutique: {
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay: {
            disableOnInteraction: false,
            delay: 2000,
          },
          loop: true,
          speed: 1000,
          observer: true,
          observeParents: true,
        },
        swiperProducts: {
          freeMode: true,
          freeModeMomentum: false,
          slidesPerView: "auto",
          observer: true,
          observeParents: true,
        },
        is_login: false,
        active_index: null,
        p_index: null,
        floor_bottom: 0
      };
    },
    methods: {
      clickSmooth(index) {
        console.log(index)
        var arr = [],
          fsOffset = 0;
        for (var i = 1; i <= this.floor_list.length; i++) {
          arr.push(
            parseInt(
              $(".floor")
              .eq(i)
              .offset().top
            ) + 30
          );
        }
        var hh = arr[index];
        console.log(arr, 'arr');
        // return;
        var clickheight = hh + fsOffset;
        $("html,body")
          .stop()
          .animate({
              scrollTop: clickheight + "px",
            },
            700
          );
        return;
        if (index == 0) {
          $(".fsFixedTop a.fsbacktotop").click(function () {
            $("html,body")
              .stop()
              .animate({
                  scrollTop: 0,
                },
                400
              );
          });
        } else {
          for (var i = 1; i <= this.floor_list.length; i++) {
            arr.push(
              parseInt(
                $(".floor")
                .eq(i)
                .offset().top
              ) + 30
            );

          }
          var hh = arr[index];
          console.log(arr, 'arr');

          var clickheight = hh + fsOffset;
          $("html,body")
            .stop()
            .animate({
                scrollTop: clickheight + "px",
              },
              750
            );
        }


      },
      // 点击推荐分类
      clickCate(index, s_index) {
        var that = this
        let cate = this.floor_list[index].cate_list[s_index]
        if (!cate.product_list.is_get) {
          if (this.loading) return;
          this.loading = true
          getFloorProducts({
            cate_id: cate.id
          }).then((res) => {
            that.loading = false
            cate.product_list = res.data
            cate.product_list.is_get = 1
            that.setOnAndDisplay(index, s_index)
          })
        } else {
          this.setOnAndDisplay(index, s_index)
        }
      },
      // 设置分类选中跟产品显示
      setOnAndDisplay(index, s_index) {
        let _index = index + 1
        let li_class = '.floor' + _index + ' .floor-right .hd li'
        let ul_class = '.floor' + _index + ' .floor-right .bd ul'
        let hd = index + ' tabs-nav hd'
        let bd = index + ' goods-list bd'
        $(li_class).removeClass('on')
        document.getElementsByClassName(hd)[0].children[s_index + 1].className += ' on'

        $(ul_class).css('display', 'none')
        document.getElementsByClassName(bd)[0].children[s_index].style.display = 'block'
      },
      // 设置楼层样式
      setFloorClass(index) {
        let _index = index + 1
        return 'floor floor' + _index + ' w1200'
      },
      // 获取楼层数组
      getFloor() {
        var that = this
        let data = {
          page: this.page,
          fids: this.fids

        }
        if (!that.is_loaded_floor) {
          getFloorList(data)
            .then((res) => {
              if (res.data.length > 0) {
                let _floor = that.floor_list.concat(res.data)
                that.floor_list = _floor
                this.page++
                if(that.fids == '0'){
                  that.fids = String(res.data[0].id)
                }else{
                  that.fids = that.fids + ',' + String(res.data[0].id)
                }
              } else {
                that.is_loaded_floor = true
              }
              that.is_get_floor = false
              that.setFloorBar()
            })
            .catch((res) => {
              that.$dialog.error(res.msg);
            });
        }

      },
      getData() {
        var that = this;
        getBannerList()
          .then((res) => {
            that.banner = res.data.banner_list;
          })
          .catch((res) => {
            that.$dialog.error(res.msg);
          });
        that.getFloor()
      },
      // 设置楼层侧边选中
      setTab() {
        var Objs = $(".floor:gt(0)");
        var textSt = $(window).scrollTop();
        for (var i = Objs.length - 1; i >= 0; i--) {
          if (textSt >= $(Objs[i]).offset().top - 50) {
            $(".fsFixedTop a")
              .eq(i)
              .addClass("active")
              .siblings()
              .removeClass("active");
            return;
          }
        }
      },
      // 设置楼层侧边
      setFloorBar() {
        var that = this
        $(function () {
          $(window).scroll(function () {
            var scrt = $(window).scrollTop();
            if (scrt > 1400) {
              $(".fsFixedTopContent")
                .show("fast", function () {
                  $(".fsFixedTop").css({
                    "-webkit-transform": "scale(1)",
                    "-moz-transform": "scale(1)",
                    transform: "scale(1)",
                    opacity: "1",
                  });
                })
                .css({
                  visibility: "visible",
                });
            } else {
              $(".fsFixedTop").css({
                "-webkit-transform": "scale(1.2)",
                "-moz-transform": "scale(1.2)",
                transform: "scale(1.2)",
                opacity: "0",
              });
              $(".fsFixedTopContent").css({
                visibility: "hidden",
              });
            }
            that.setTab();
          });
        });
      }
    },
    mounted() {
      var that = this;
      if (
        this.$cookie.get("login_status") &&
        this.$cookie.get("login_status") != ""
      ) {
        getUser().then((res) => {
          that.user = res.data;
        });
        this.is_login = true;
      }
      this.getData();

      this.$nextTick(function () {

        // 滚动条到页面底部加载更多案例
        $(window).scroll(function () {
          var scrollTop = $(this).scrollTop(); //滚动条距离顶部的高度
          var scrollHeight = $(document).height(); //当前页面的总高度
          var clientHeight = $(this).height(); //当前可视的页面高度
          if (scrollTop + clientHeight >= scrollHeight - 450) { //距离顶部+当前高度 >=文档总高度 即代表滑动到底部
            //滚动条到达底部
            if (that.$route.path == '/') {

              if (!that.is_get_floor) {
                that.is_get_floor = true
                that.getFloor()
              }
              if (that.is_loaded_floor) {
                var scrt = $(window).scrollTop();
                var arr = [],
                  fsOffset = 0;
                for (var i = 1; i <= that.floor_list.length; i++) {
                  arr.push(
                    parseInt(
                      $(".floor")
                      .eq(i)
                      .offset().top
                    ) + 30
                  );

                }
                that.floor_bottom = arr[that.floor_list.length - 1]
                if (scrt > that.floor_bottom) {
                  that.$nextTick(function () {
                    $(".fsFixedTop").css({
                      "-webkit-transform": "scale(1.2)",
                      "-moz-transform": "scale(1.2)",
                      transform: "scale(1.2)",
                      opacity: "0",
                    });
                    $(".fsFixedTopContent").css({
                      visibility: "hidden",
                    });
                  })
                }
              }
            }

          }
        });

      })

    },
    beforeDestroy() {
      this.$emit("page", "other");
    },
  };
</script>

<style scoped>
  .w_pic {
    max-width: 1200px;
    max-height: 117px;
  }

  .h_pic {
    max-width: 243px;
    max-height: 614px;
  }

  .floor_wrap {
    margin-top: 20px;
  }

  .fsFixedTopContent {
    display: none;
    overflow: visible;
    width: 50px;
    height: auto;
    position: fixed;
    left: 50%;
    top: 20%;
    margin: -150px 0 0 -675px;
    z-index: 3333;
  }

  .fsFixedTop {
    width: 40px;
    height: auto;
    background: #fdfdfd;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    -webkit-transform: scale(1.2);
    -moz-transform: scale(1.2);
    transform: scale(1.2);
    opacity: 0;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    transition: all 0.3s ease;
    position: absolute;
    left: 0;
    top: 0;
  }

  .fsFixedTop a {
    width: 36px;
    height: 36px;
    line-height: 36px;
    display: block;
    position: relative;
    cursor: pointer;
    text-decoration: none;
    padding: 2px;
    border-top: 1px solid #d4d4d4;
  }

  .fsFixedTop b {
    width: 36px;
    height: 36px;
    color: #333;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    display: block;
  }

  .fsFixedTop .fs-name {
    width: 36px;
    height: 36px;
    line-height: 18px;
    color: #ff4040;
    text-align: center;
    display: none;
    overflow: hidden;
    font-size: 13px;
    letter-spacing: 1px;
    word-wrap: break-word;
  }

  .fsFixedTop a.active {
    background: #ff4040;
  }

  .fsFixedTop a.active .fs-name {
    color: #fff;
    display: block;
  }

  .fsFixedTop a.active .fs {
    display: none;
  }

  .fsFixedTop a.active .fs-name:hover {
    background: #ff4040;
    text-decoration: none;
  }

  .fsFixedTop a:hover {
    background: #ff4040;
  }

  .fsFixedTop a:hover .fs-name {
    display: block;
    color: #fff;
  }

  .fsFixedTop a:hover b {
    display: none;
  }

  .floor_wrap {
    padding-bottom: 50px;
  }

  .floor {
    padding-bottom: 100px;
  }

  .floor0 {
    display: none;
  }
</style>
